import keyboard from './keyboard.vue'
export default keyboard


// WEBPACK FOOTER //
// ./src/components/keyboard/index.js